export default {
  init() {
    // JavaScript to be fired on all pages

    var $hamburger = $('.hamburger');
    $hamburger.on('click', function() {
      $hamburger.toggleClass('is-active');
      // Do something else, like open/close menu
      $('body').toggleClass('menu-open');
    });

    function detect_scrolled(){

      if($(window).scrollTop() > 100){
        $( 'body' ).addClass( 'scrolled' );
      } else{
        $( 'body' ).removeClass( 'scrolled' );
      }

    }

    var scrollInterval = null;

    $(window).scroll(function(){ detect_scrolled(); });

    $(window).on('touchmove', function() {
      scrollInterval = window.setInterval('detect_scrolled', 100);
    });
    $(window).on('touchend', function() {
      clearInterval(scrollInterval);
    });

    detect_scrolled();

    $('form.mepr-form :input').each(function(index, elem) {

      var eId = $(elem).attr('id');

      var label = null;

      if (eId && (label = $(elem).parents('form').find('label[for='+eId+']')).length === 1) {

          var placeholder = $(label).html();
          $(elem).attr('placeholder', placeholder.replace(':',' '));

          if (!$(label).hasClass('mepr-checkbox-field')) {
            $(label).addClass('sr-only');
          }

      }

    });

    // close mobile menu when clicking outside of it.
    $(document).mouseup(function(e){
       var menu = $('#main_navigation');
       if (!menu.is(e.target) // The target of the click isn't the container.
       && menu.has(e.target).length === 0) // Nor a child element of the container
       {
          menu.removeClass('show');
          $hamburger.removeClass('is-active');
          $('body').removeClass('menu-open');
       }
    });

    // Disable first option in select fields
    // $('select option:first-child').attr('disabled', 'true');

     // matchHeight
    if (typeof matchHeight == 'function') {
      $(function() {
        $('.matchHeight').matchHeight();
      });
    }

    // toggle accordion chevron
    $('.card-header button').on('click', function(){
      $(this).find('i').toggleClass('rotated');
    });
    $('#accordionFaqs').on('hidden.bs.collapse', function () {
      $('i').removeClass('rotated');
    });

    // Slick
    $('.slick.slider').slick({
      infinite: true,
      centerMode: true,
      variableWidth: true,
      adaptiveHeight: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      appendArrows: $('.arrows'),
      prevArrow: '<button id="prev" type="button" class="btn"><i class="fas fa-caret-left fa-2x text-white" aria-hidden="true"></i></button>',
      nextArrow: '<button id="next" type="button" class="btn"><i class="fas fa-caret-right fa-2x text-white" aria-hidden="true"></i></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // init Isotope
    var $grid = $('.filter-grid').isotope({
      itemSelector: '.event-item',
    });
    var $noResultsContainer = $('#noResultsContainer');

    // store filter for each group
    var filters = {};

    $('.button-group').on( 'click', 'button', function() {
      var $this = $(this);
      // get group key
      var $buttonGroup = $this.parents('.button-group');
      var filterGroup = $buttonGroup.attr('data-filter-group');
      // set filter for group
      filters[ filterGroup ] = $this.attr('data-filter');
      // combine filters
      var filterValue = concatValues( filters );
      $grid.isotope({ filter: filterValue });

      // no results
      if ($grid.data('isotope').filteredItems.length == 0) {
        $noResultsContainer.show();
      } else {
        $noResultsContainer.hide();
      }
    });

    // change is-checked class on buttons
    $('.button-group').each( function( i, buttonGroup ) {
      var $buttonGroup = $( buttonGroup );
      $buttonGroup.on( 'click', 'button', function( event ) {
        $buttonGroup.find('.is-checked').removeClass('is-checked');
        var $button = $( event.currentTarget );
        $button.addClass('is-checked');
      });
    });

    // flatten object by concatting values
    function concatValues( obj ) {
      var value = '';
      for ( var prop in obj ) {
        value += obj[ prop ];
      }
      return value;
    }

    // reset filters
    var $anyButtons = $('.filters').find('button[data-filter=""]');
    var $buttons = $('.filters button');

     $('.clear-filters').on( 'click', function() {
       // reset filters
       filters = {};
       $grid.isotope({ filter: '*' });
       // reset buttons
       $buttons.removeClass('is-checked');
       $anyButtons.addClass('is-checked');
       $noResultsContainer.hide();
     });

    // // store filter for each group
    // var filters = [];
    //
    // // change is-checked class on buttons
    // $('.button-group').on( 'click', 'button', function( event ) {
    //   var $target = $( event.currentTarget );
    //   $target.toggleClass('is-checked');
    //   var isChecked = $target.hasClass('is-checked');
    //   var filter = $target.attr('data-filter');
    //   if ( isChecked ) {
    //     addFilter( filter );
    //   } else {
    //     removeFilter( filter );
    //   }
    //   // filter isotope
    //   // group filters together, inclusive
    //   $grid.isotope({ filter: filters.join(',') });
    // });
    //
    // function addFilter( filter ) {
    //   if ( filters.indexOf( filter ) == -1 ) {
    //     filters.push( filter );
    //   }
    // }
    //
    // function removeFilter( filter ) {
    //   var index = filters.indexOf( filter );
    //   if ( index != -1 ) {
    //     filters.splice( index, 1 );
    //   }
    // }

    // var $isotope = {
    //   itemSelector: '.item',
    //   hiddenStyle: {
    //     opacity: 0,
    //   },
    //   visibleStyle: {
    //     opacity: 1,
    //   },
    // };
    // var $grid;
    // var arrInclusives = [];
    // // filter with selects and checkboxes
    // var $checkboxes = $('#form-ui input');
    // var isIsotopeInit = false;
    // // grid
    // if($('.grid').length){
    //   $grid = $('.grid');
    // }
    // if($('.row.grid').length){
    //   $grid = $('.row.grid');
    //   $isotope.layoutMode = 'fitRows';
    // }
    // if($('.accordion.grid').length){
    //   $grid = $('.accordion.grid');
    // }
    //
    // function getHashFilter() {
    //   // var hash = location.hash;
    //   // get filter=filterName
    //   var matches = location.hash.match( /filter=([^&]+)/i );
    //   var hashFilter = matches && matches[1];
    //   return hashFilter && decodeURIComponent( hashFilter );
    // }
    //
    // function onHashchange() {
    //   if(typeof $grid !== 'undefined'){
    //     var hashFilter = getHashFilter();
    //     if ( !hashFilter && isIsotopeInit && !typeof isotope == 'function') {
    //       return;
    //     }
    //     isIsotopeInit = true;
    //
    //     $isotope.filter = hashFilter;
    //     $grid.isotope($isotope);
    //
    //     // set selected class on button
    //     if ( hashFilter ) {
    //       arrInclusives = hashFilter.length ? hashFilter.split(',') : '';
    //
    //       arrInclusives.forEach(function(item){
    //         $('#'+item.split('.').join('')).prop('checked', true);
    //       });
    //     }
    //   }
    // }
    //
    // $checkboxes.change( function() {
    //   // inclusive filters from checkboxes
    //   arrInclusives = [];
    //   $('#form-ui input:checkbox').each(function(){
    //     if($(this).is(':checked')){
    //       arrInclusives.push($(this).val());
    //     }
    //   });
    //
    //   // combine inclusive filters
    //   var filterAttr = arrInclusives.length ? arrInclusives.join(',') : '*';
    //   // set filter in hash
    //   location.hash = 'filter=' + encodeURIComponent( filterAttr );
    //
    //   $grid.isotope({filter: filterAttr});
    // });
    //
    // // resets height, stops items collsapsing into others
    // $('.accordion.grid .item').css('position', 'static');
    // $('.accordion.grid .item').css({'top': 0, 'left': 0});
    //
    // if(typeof $grid !== 'undefined'){
    //   $grid.on('layoutComplete', function() {
    //     $('.accordion.grid').css('height', 'auto');
    //     $('.accordion.grid .item').css({'position': 'static', 'opacity': 1});
    //   });
    // }

    // $(window).on( 'hashchange', onHashchange );
    // // trigger event handler to init Isotope
    // onHashchange();

    // Scroll to opened accordion card
    $('.card .collapse').on('shown.bs.collapse', function(){
      var target = $(this).attr('id');
      $('html,body').animate({scrollTop: $('#' + target).offset().top -150}, 600);
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js